module.exports = __webpack_public_path__ + "src/assets/models/spectrophotometer/water_dist.fbx";